import React, { createContext, useState } from "react";
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard } from '@ionic/react';
import { Route, Link} from "react-router-dom";

import cssClass from '../pages/zPublic/css/zPublic.module.css';

import ProServiceMerchant_Homepage from '../pages/zPublic/components/Homepage_proService';
import Hotels_Homepage from '../pages/zPublic/components/Homepage_hotel';

import { Home_ProfessionalServicesList } from "../pages/zPublic/views/Home";
import { Home_HotelsList } from "../pages/zPublic/views/Home";

export const Public_MerchantID_Context = createContext({
    companyID: null,
    companyName: 'ZASAVA',
    changeCompanyID: (data_id) => {},
    changeCompanyName: (data_name) => {},

});

export function PublicMerchantID_provider (props) {

    let [merchantID, setMerchantID] = useState(null);
    let [merchantName, setMerchantName] = useState('ZASAVA');

    function changeCompanyIDHandler(data_id) {
        //alert('In changeCompanyIDHandler');

        setMerchantID((prev) => { return data_id} );

    }

    function changeCompanyNameHandler(data_name) {
    //alert('In changeCompanyNameHandler');

        setMerchantName(data_name);

    }


    const context = {
        companyID: merchantID,
        companyName: merchantName,
        changeCompanyID: changeCompanyIDHandler,
        changeCompanyName: changeCompanyNameHandler,

    };

    alert('In Public_merchantID_context');
    

    return <Public_MerchantID_Context.Provider value={context}>

                    {props.children}

    </Public_MerchantID_Context.Provider>
}

